<template>
    <div class="row animated fadeIn">
        <div class="col-12">
            <div class="card" v-if="asyncDone === false">
                <!-- Show the loader when async operation is going on -->
                <div class="loader"></div>
            </div>
        </div>
        <div class="col-12" v-if="asyncDone">
            <div class="table-responsive">
                <table class="table">
                    <thead class="text-primary">
                        <tr>
                            <th class="text-center">Ticket #</th>
                            <th>Subject</th>
                            <th>Last Reply Date</th>
                            <th class="text-center">Current Status</th>
                            <th class="text-right">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr v-for="ticket in tickets" :key="ticket.ticket_number">
                        <td class="text-center">{{ ticket.ticket_number }}</td>
                        <td>{{ getTicketSubject(ticket.tsubject) }}</td>
                        <td>{{ ticket.lastreply_date }}</td>
                        <td class="text-center"><span class="badge badge-pill" :class="getTicketStatusClass(ticket.status)">{{ ticket.status }}</span></td>
                        <td class="text-right">
                            <button class="btn btn-primary btn-sm" @click="fetchTicketDetail(ticket.ticket_number.toString())">View Ticket</button>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="center">
                    <ul class="pagination pagination-primary">
                        <li class="page-item" :class="{ 'active' : selectedPage === index }" v-for="(page, index) in pages" :key="index">
                            <button class="page-link" type="button" @click.prevent="fetchTickets(index)">{{ page }}</button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="modal" tabindex="-1" role="dialog" id="viewTicketModal" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h6 class="modal-title">Ticket #: {{ticket.ticket_number}}</h6>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" style="background: #aaaaaa">
                        <div class="row animated fadeIn">
                            <div class="col-12" v-if="ticketLoading">
                                <div class="card">
                                    <!-- Show the loader when async operation is going on -->
                                    <div class="loader"></div>
                                </div>
                            </div>
                            <div class="col-12" v-else>
                                <div class="card mb-0">
                                    <div class="card-header mt-3">
                                        <h4 class="card-title ml-4 d-inline-block">#{{ ticket.ticket_number }} - {{ ticket.subject }}</h4>
                                        <span class="badge badge-pill d-inline-block float-right mr-4 mt-3" :class="getTicketStatusClass(ticket.status)">{{ ticket.status }}</span>
                                    </div>
                                    <div class="card-body pl-5 pr-5">
                                        <p class="pre-wrap" v-html="formattedText(ticket.body)"></p>
                                        <p class="text-secondary text-right" style="font-size: 12px;"><span class="text-info">Opened By:</span> {{ ticket.name }} on {{ ticket.date }}</p>
                                    </div>
                                </div>
                                <div class="card card-timeline card-plain mb-0">
                                    <div class="card-body">
                                        <ul class="timeline timeline-simple mb-0">
                                            <li class="timeline-inverted" v-for="(reply, index) in replies" :key="index">
                                                <div class="timeline-badge" style="border: none;">
                                                    <img :src="`https://www.gravatar.com/avatar/${reply.gravatar}?s=50`" width="50px" height="50px" />
                                                </div>
                                                <div class="timeline-panel">
                                                    <div class="timeline-heading">
                                                        <i class="fa fa-reply mr-1" aria-hidden="true"></i> Reply By: <span class="badge badge-pill ml-2" :class="{ 'badge-info' : (reply.type === 'Client' || reply.type === 'Email'), 'badge-success': !(reply.type === 'Client' || reply.type === 'Email') }">{{ reply.name }}</span>
                                                    </div>
                                                    <div class="timeline-body">
                                                        <p class="pre-wrap" v-html="formattedText(reply.body)"></p>
                                                    </div>
                                                    <a  href="javascript:void(0);" class="pull-right" v-for="(attachment, attach_index) of attachments[reply.id]" :disabled="loading === attachment.id" :key="attach_index" @click="downloadAttachment(attachment)">
                                                      <div class="loader" v-if="loading === attachment.id" style="width: 30px;height: 30px; margin: 0 auto !important;"></div>
                                                      <span v-else>Attachment <i class="fa fa-paperclip"/></span>
                                                    </a>
                                                    <h6>
                                                        <i class="fa fa-clock-o mr-2"></i> {{ reply.date }}
                                                    </h6>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <ReplyBox :ticket="ticket" :clientId="clientID" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-default btn-sm" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { functions } from "@/firebase/init"
    import autoLink from 'autolink.js';
    import swal from 'sweetalert2';

    export default {
        name: "TicketsArchiveCollaborator",
        data() {
            return {
                loading: null,
                tickets: [],
                pageCount: null,
                selectedPage: 0,
                ticket: {},
                replies: [],
                ticketLoading: true,
                attachments: {}
            }
        },
        computed: {
            asyncDone() {
                return this.$store.getters["async/state"];
            },
            pages() {
                if(this.pageCount !== null) {
                    const pages = [];
                    for(let i = 1; i<= this.pageCount; i++) {
                        pages.push(i)
                    }
                    return pages
                }
            },
            clientID() {
                return this.$store.getters.getRequestCustomerID;
            }
        },
        components: {
            ReplyBox: () =>
                import(/* webpackChunkName: "migrationIntro" */ "../../../components/Helps/TicketReplyBox.vue"),
        },
        mounted () {
          console.log('Mounted Called');
          this.fetchTickets(0);
          /* eslint-disable */
            $('#viewTicketModal').on('hidden.bs.modal', () => {
                this.ticketLoading = true;
            })
          /* eslint-enable */
        },
        methods: {
          async downloadAttachment (attachment) {
            this.loading = attachment.id;
            try {
              const response = await this.$http.post('host-bill/download-attachment', {
                id: attachment.id,
                grant_type: 'token'
              });
              const linkSource = `data:application/pdf;base64,${response.data.base64}`;
              const downloadLink = document.createElement("a");
              const fileName = 'attachment.' + response.data.type;

              downloadLink.href = linkSource;
              downloadLink.download = fileName;
              downloadLink.click();
              this.loading = null;
            } catch (e) {
              this.loading = null;

              await this.$store.dispatch("alert/update", {
                type: "error",
                message: e.message,
                show: true
              })
              this.addLog({
                message: "Error: Download Attachment, Message:" + e.message,
                level:  "error"
              })
              setTimeout(() => {
                this.$store.dispatch("alert/showUpdate", { show: false })
              }, 5000)
            }
          },
            getTicketSubject(tsubject) {
                const strSplit = tsubject.split('-')
                strSplit.splice(0, 1)
                const sub = strSplit.join('-')
                return sub.trim()
            },
            getTicketStatusClass(status) {
                return {
                    "badge-success": status === "Answered",
                    "badge-warning": status === "In-Progress",
                    "badge-info": (status === "Open" || status === "Sales Followup"),
                    "badge-primary": (status === "Client-Reply" || status === "Waiting on Billing"),
                    "badge-default": status === "Closed"
                }
            },
            formattedText(text) {
                return autoLink(text, {
                    // default options:
                    email: true,
                    image: true,
                    linkAttr: {
                        'target': '_blank',
                        'rel': 'nofollow'
                    },
                    // \n to <br/>
                    br: true
                })
            },
            async fetchTicketDetail(ticketNumber) {
                console.log(ticketNumber);
                /* eslint-disable */
                $('#viewTicketModal').modal('show');
                $('.modal-backdrop').removeClass("modal-backdrop");
                /* eslint-enable */

              try {
                const response = await this.$http.post('host-bill/fetch-ticket-details', {
                  ticketID: ticketNumber,
                  grant_type: 'token'
                });
                console.log(response.data)
                this.ticket = {
                  ...response.data.ticket
                }
                let ticketReplies = response.data.replies;

                if(!Array.isArray(ticketReplies)) {
                  ticketReplies = Object.values(response.data.replies)
                }

                this.replies = [
                  ...ticketReplies
                ]
                this.attachments = response.data.attachments
              } catch (e) {
                this.ticketLoading = false;

                swal('Error!', 'Error in fetching ticket detail', 'error');

                await this.addLog({
                  message: "Error: View Ticket, Message:" + e.message,
                  level: "danger"
                });

                setTimeout(() => {
                  this.$store.dispatch("alert/showUpdate", { show: false })
                }, 5000)
              }
              this.ticketLoading = false;
            },
            fetchTickets(pageNo) {
                this.selectedPage = pageNo;

                this.$store.dispatch("async/stateUpdate", { state: false });

                const fetchSupportTicketsByPage = functions.httpsCallable("fetchSupportTicketsByPage");
                fetchSupportTicketsByPage({
                    clientID: this.clientID,
                    page: pageNo
                })
                    .then(response => {
                        console.log(response);
                        this.$store.dispatch("async/stateUpdate", { state: true });

                        this.pageCount = response.data.pageCount;

                        this.tickets = [
                            ...response.data.supportTickets
                        ]
                    })
                    .catch(err => {
                        this.$store.dispatch("async/stateUpdate", { state: true });

                        this.$store.dispatch("alert/update", {
                            type: "error",
                            message: err.message,
                            show: true
                        });

                        this.addLog({
                            message: "Error: Archive Ticket, Message:" + err.message,
                            level:  "danger"
                        });

                        setTimeout(() => {
                            this.$store.dispatch("alert/showUpdate", { show: false })
                        }, 5000)
                    })
            }
        }
    }
</script>

<style scoped>

</style>
